import { primaryIntegrationType } from 'lib/clientIntegration';
import Client from 'models/Client';

/**
 * Mirrors olio-integration's filename convention so the front-end
 * placeholder matches the file the integration ultimately renders:
 *
 *   {SOURCE_SYSTEM}_CCD_{LastName}_{MMDDYYYY}.pdf
 *
 * Example: PCC_CCD_Baptista_04292026.pdf
 */
export function ccdFilename({
  client,
  patientName,
  date = new Date(),
}: {
  client?: Client | null;
  patientName: string;
  date?: Date;
}): string {
  const source = primaryIntegrationType(client)?.toUpperCase() ?? 'CCD';
  const lastName = extractLastName(patientName);
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const yyyy = date.getFullYear();
  return `${source}_CCD_${lastName}_${mm}${dd}${yyyy}.pdf`;
}

/**
 * Pull a filename-safe last name out of the patient's display name.
 * Mirrors `_patient_last_name` on the backend: strip non-alphanumerics,
 * fall back to "unknown" when nothing usable is present.
 */
function extractLastName(name: string): string {
  const parts = (name || '').trim().split(/\s+/);
  const last = parts.length > 0 ? parts[parts.length - 1] : '';
  const sanitized = last.replace(/[^A-Za-z0-9]+/g, '');
  return sanitized || 'unknown';
}

function pad(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}
